// import get from 'lodash/get';
import { IOrderPriceDetails } from '@/slices/gom/apis/index.d';
import { IPassengerSearchForm, TPassenger } from '../slices/passenger/slices/type.d';
import { FlightData } from '../slices/flightData/slices/index.d';

export function getTotalTripPrice(
  selectedFlight: FlightData | null,
  passenger: IPassengerSearchForm,
): number {
  if (!selectedFlight) {
    return 0;
  }

  const totalAdultPrice = passenger.adt
    * (selectedFlight.route.schedules[0].totalPriceAdult);
  const totalChildPrice = passenger.chd
    * (selectedFlight.route.schedules[0].totalPriceChild);
  const totalChildInfPrice = passenger.inf
    * (selectedFlight.route.schedules[0].totalPriceInfant);
  const totalPrice = Number(totalAdultPrice || 0)
    + Number(totalChildPrice || 0)
    + Number(totalChildInfPrice || 0);
  return totalPrice;
}

export function getRawTotalTripPrice(
  selectedFlight: FlightData | null,
  passenger: IPassengerSearchForm,
): number {
  if (!selectedFlight) {
    return 0;
  }

  const currentSchedule = selectedFlight.route?.schedules[0];
  const totalAdultPrice = passenger.adt
    * (currentSchedule.totalPriceAdultOriginal || currentSchedule.totalPriceAdult);
  const totalChildPrice = passenger.chd
    * (currentSchedule.totalPriceChildOriginal || currentSchedule.totalPriceChild);
  const totalChildInfPrice = passenger.inf
    * currentSchedule.totalPriceInfant;
  const totalPrice = Number(totalAdultPrice || 0)
    + Number(totalChildPrice || 0)
    + Number(totalChildInfPrice || 0);
  return totalPrice;
}

export function getDiscountAmount(
  selectedFlight: FlightData | null,
  passenger: IPassengerSearchForm,
): number {
  if (!selectedFlight) {
    return 0;
  }

  const currentSchedule = selectedFlight.route?.schedules[0] || {};
  const originalDiscountAmount = currentSchedule.discountAmount;

  const totalAdultPrice = passenger.adt
    * originalDiscountAmount;
  const totalChildPrice = passenger.chd
    * originalDiscountAmount;
  const totalPrice = Number(totalAdultPrice || 0)
    + Number(totalChildPrice || 0);
  return totalPrice;
}

export function getTotalPassenger(
  passenger: IPassengerSearchForm,
): number {
  return passenger?.adt + passenger?.chd + passenger?.inf;
}

export function getTotalDiscountAmount(
  discountAmount: number,
  passenger: IPassengerSearchForm,
): number {
  const totalSeats = passenger?.adt + passenger?.chd;
  return totalSeats * discountAmount;
}

export function getPriceDetailsOnType(
  flightData: FlightData,
  passenger: TPassenger,
  noOfPassenger: number,
) {
  const priceDiff = flightData.priceDiff ? (flightData.priceDiff / noOfPassenger) : 0;
  // eslint-disable-next-line max-len
  // const cheapestDiscount = (get(flightData, 'cheapestDiscount', 0) + get(flightData, 'cheapestDiscountReturn', 0)) || 0;
  const priceDetails: IOrderPriceDetails = {
    route: flightData.startPoint + flightData.endPoint,
    fare: 0,
    tax: 0,
    fee: 0,
    service_fee: 0,
    updated_price_diff: priceDiff,
    total_price: 0,
    pt: (passenger.type !== 'inf' && flightData.route.schedules[0].priceTypeArr) || [],
    // pt: [9, ...(passenger.type !== 'inf' ? [cheapestDiscount] : [])],
  };
  const {
    fareAdultOriginal, fareAdult, fareChildOriginal, fareChild, fareInfant,
    feeAdult, feeChild, feeInfant,
    serviceFeeAdult, serviceFeeChild, serviceFeeInfant,
    taxAdult, taxChild, taxInfant, totalPriceAdult, totalPriceChild,
    totalPriceAdultOriginal, totalPriceChildOriginal, totalPriceInfant,
  } = flightData.route.schedules[0];

  switch (passenger.type) {
    case 'adt':
      priceDetails.fare = fareAdultOriginal || fareAdult;
      priceDetails.fee = feeAdult;
      priceDetails.service_fee = serviceFeeAdult;
      priceDetails.tax = taxAdult;
      priceDetails.total_price = totalPriceAdultOriginal || totalPriceAdult;
      break;
    case 'chd':
      priceDetails.fare = fareChildOriginal || fareChild;
      priceDetails.fee = feeChild;
      priceDetails.service_fee = serviceFeeChild;
      priceDetails.tax = taxChild;
      priceDetails.total_price = totalPriceChildOriginal || totalPriceChild;
      break;
    case 'inf':
      priceDetails.fare = fareInfant;
      priceDetails.fee = feeInfant;
      priceDetails.service_fee = serviceFeeInfant;
      priceDetails.tax = taxInfant;
      priceDetails.total_price = totalPriceInfant;
      break;
    default:
      break;
  }

  return priceDetails;
}

export function aggregatePassengerTypes(passengerArr: TPassenger[]) {
  const passengerObj: IPassengerSearchForm = {
    adt: 0,
    chd: 0,
    inf: 0,
  };

  passengerArr.forEach((passenger) => {
    passengerObj[passenger.type] += 1;
  });

  return passengerObj;
}
